/**
 * gamesCatalog.js
 *
 * Единый источник правды для раздела «Игры» на странице /service/games.
 *
 * Зачем отдельный файл:
 * - GamesPage.js отвечает только за layout, поиск и проверку подписки.
 * - Список игр — это конфигурация, а не UI. Его проще править и ревьюить отдельно.
 * - При добавлении новой игры меняем только этот файл (и превью в public/games_previews/).
 *
 * Поля объекта игры:
 * - id         — уникальный идентификатор (для key в React.map)
 * - index      — порядок сортировки на странице (меньше = выше)
 * - name       — заголовок на карточке / в баннере
 * - description— короткое описание под названием
 * - image_path      — широкая обложка для featured-баннера (может быть с fade слева)
 * - tile_image_path — чистая full-bleed обложка для сетки и новостей
 *                     (обязательна для featured-игр, чтобы fade не попал в карточки)
 * - link       — маршрут React Router (/game/...)
 * - is_download— legacy-поле из библиотеки материалов, для игр всегда false
 * - folder     — legacy-поле из библиотеки, для игр пустое
 * - featured   — (опционально) true = показываем в большом баннере на desktop
 *
 * Важно: массив НЕ мутируем после импорта. Если нужна сортировка — делаем копию [...GAMES_CATALOG].
 */

export const GAMES_CATALOG = [
  {
    id: 1,
    index: 1,
    name: "What's Missing?",
    description: "Memory + vocabulary: spot the missing picture",
    image_path: "whats-missing-v2.png",
    link: "/game/whats-missing",
    is_download: false,
    folder: "",
  },
  {
    id: 2,
    index: 2,
    name: "Magic Sentence",
    description: "Build correct sentences from shuffled words",
    image_path: "magic-sentence-v2.png",
    link: "/game/magic-sentence",
    is_download: false,
    folder: "",
  },
  {
    id: 3,
    index: 3,
    name: "Hangman",
    description: "Guess the word letter by letter",
    image_path: "hangman-v2.png",
    link: "/game/hangman",
    is_download: false,
    folder: "",
  },
  {
    id: 4,
    index: 4,
    name: "Horse Race",
    description: "Quiz race — correct answers move your horse",
    image_path: "horse-race-v2.png",
    link: "/game/horse-race",
    is_download: false,
    folder: "",
  },
  {
    id: 5,
    index: 5,
    name: "Story Builder",
    description: "Create a story, then answer questions",
    image_path: "story-builder-v2.png",
    link: "/game/story-builder",
    is_download: false,
    folder: "",
  },
  {
    id: 6,
    index: 6,
    name: "Talk Quest",
    description: "Dice, city map, and everyday roleplay scenes",
    image_path: "talk-quest-v2.png",
    tile_image_path: "talk-quest-tile-v2.png",
    link: "/game/talk-quest",
    is_download: false,
    folder: "",
  },
  {
    id: 7,
    index: 7,
    name: "Critter Quiz",
    description:
      "Picture grammar quiz, choose correct answers and unlock critters",
    image_path: "critter-quiz-v2.png",
    tile_image_path: "critter-quiz-tile-v2.png",
    link: "/game/critter-quiz",
    is_download: false,
    folder: "",
    featured: true,
  },
];
